import { createContext, useContext } from 'react';

export const OpenParticipantTabContext = createContext<((participantId: string) => void) | null>(null);

export function useOpenParticipantTab(): ((participantId: string) => void) | null {
  return useContext(OpenParticipantTabContext);
}
